import React, { useState, useEffect } from "react"
import "./liquid-modal.css"
import Modal from "@kit/design/modal"
import Button from "@kit/design/button"
import useFetch from "hooks/use-new-fetch"
import SelectMenu from "@kit/design/select-menu"
import cx from "classnames"

const liquidSnippets = [
  {
    label: "Subscriber first name",
    subtitle: "Output the subscriber's first_name field",
    insertCode: "{{ subscriber.first_name }}"
  },
  {
    label: "Personalized greeting",
    subtitle: "Include the subscriber's first_name in a greeting, if it exists",
    insertCode: 'Hello {{ subscriber.first_name | strip | default: "there" }},'
  },
  {
    label: "Subscriber email address",
    subtitle: "Output the subscriber’s email field",
    insertCode: "{{ subscriber.email_address }}"
  },
  {
    label: "Subscriber tags conditional",
    subtitle: "If / else statement using the subscriber’s tags.",
    insertCode:
      '{% if subscriber.tags contains "Tag Name" %} \nThe subscriber has the tag \n{% else %}\nThe subscriber does not have the tag \n{% endif %}'
  }
]

function CustomFields(props) {
  const [request] = useFetch("/api/v3/custom_fields")
  const [customFields, setCustomFields] = useState([])
  const [field, setField] = useState(null)

  useEffect(() => {
    request.get().then(({ data }) => {
      setCustomFields(data.custom_fields)
    })
  }, [])

  const handleChange = event => {
    const field = customFields.find(f => f.id === event.target.value)
    setField(field)
  }

  return (
    customFields.length > 0 && (
      <div
        key="custom-fields"
        className="border p-4 rounded flex flex-col justify-between items-start mt-5"
      >
        <h3 className="text-gray-800 font-semibold mb-2">
          Subscriber custom fields
        </h3>
        <p className="mb-3 text-gray-700 text-xs">
          Output your custom defined subscriber field
        </p>
        <div className="w-full">
          <SelectMenu
            type="autocomplete"
            name="field"
            options={customFields.map(field => ({
              label: field.label,
              value: field.id
            }))}
            onChange={handleChange}
            placeholder="Choose a field"
          />
        </div>
        <Button
          className={cx(
            "font-semibold mt-3 uppercase hover:text-blue-800 flex items-center",
            {
              "text-gray-300 cursor-not-allowed": !field,
              "text-blue-500": !!field
            }
          )}
          onClick={() => {
            props.setModal(false)
            props.insertSnippet(`{{ subscriber.${field.key} }}`)
          }}
          disabled={!field}
          icon="plus-circle"
        >
          Add to email
        </Button>
      </div>
    )
  )
}

function LiquidModal(props) {
  return (
    <>
      {props.isOpen && (
        <Modal
          label="Personalization"
          onClose={() => props.setModal(false)}
          className=""
        >
          <p className="py-5 text-gray-800 border-t border-gray-200">
            Add a personal touch to your email using these liquid snippets. You
            can output subscriber data or change email content using
            conditionals.
          </p>
          <div className="liquid-modal">
            {liquidSnippets.map((snippet, index) => {
              return (
                <div
                  index={index}
                  key={index}
                  className="border p-4 rounded flex flex-col justify-between items-start"
                >
                  <h3 className="text-gray-800 font-semibold mb-2">
                    {snippet.label}
                  </h3>
                  <p className="mb-3 text-gray-700 text-xs">
                    {snippet.subtitle}
                  </p>
                  <Button
                    className="text-blue-500 font-semibold mt-3 uppercase hover:text-blue-800 flex items-center"
                    onClick={() => {
                      props.setModal(false)
                      props.insertSnippet(snippet.insertCode)
                    }}
                    icon="plus-circle"
                  >
                    Add to email
                  </Button>
                </div>
              )
            })}
          </div>
          <CustomFields {...props} />
        </Modal>
      )}
    </>
  )
}

export default LiquidModal
